import { useState, useRef, useEffect } from "react";
import SelectAvatar from "./components/SelectAvatar";
import SignIng from "./components/SignIn";
import SignUp from "./components/Signup";
import { supabase } from "../supabase/client";
import { useNavigate } from "react-router-dom";
import { useUser } from "../context/Usercontext";
import Button from "../minicomponents/Button";

let Login = () => {
  const navigate = useNavigate();
  let { isSession, getSession, user, setUser } = useUser();
  let [isUser, setIsUser] = useState(false);
  useEffect(() => {
    let gettingSession = async function () {
      const { data, error } = await supabase.auth.getSession();
      //
      if (data.session) {
        navigate("/profile");
      }
    };
    gettingSession();
  }, [navigate]);

  //

  let changeForm = () => {
    setIsUser(!isUser);
  };

  return (
    <div className="main-login">
      <div className="left-side">
        <span>Say facts</span>
      </div>
      <div className="right-side">
        <div className="right-side-header">
          <h1>{isUser ? "Sign up" : "Log in"}</h1>
          <Button
            buttonStyle={"button-style-2 button-width-50"}
            onPress={changeForm}
          >
            {isUser ? "I'm already user" : "I'm new"}
          </Button>
        </div>

        <div>{!isUser ? <SignIng /> : <SignUp />}</div>
      </div>
    </div>
  );
};

export default Login;
